import React from "react";

const PaymentDetailsContext = React.createContext();

export default PaymentDetailsContext;
